function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("mask", {
  id: "path-1-inside-1",
  fill: "white"
}, /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M13.5199 12.7655C16.0789 12.087 17.9649 9.75496 17.9649 6.98246C17.9649 3.67844 15.2865 1 11.9825 1C8.67843 1 6 3.67844 6 6.98246C6 9.23641 7.24648 11.1992 9.08772 12.2192V20.2982L11.7895 23L14.6842 20.1053L13.1404 18.5614L14.6842 17.0175L13.1404 15.4737L14.6842 13.9298L13.5199 12.7655Z"
}));

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M13.5199 12.7655L13.1354 11.3156C12.6168 11.4531 12.2111 11.8573 12.0715 12.3754C11.932 12.8935 12.0798 13.4467 12.4592 13.8262L13.5199 12.7655ZM9.08772 12.2192H10.5877V11.3354L9.81458 10.9071L9.08772 12.2192ZM9.08772 20.2982H7.58772V20.9196L8.02706 21.3589L9.08772 20.2982ZM11.7895 23L10.7288 24.0607L11.7895 25.1213L12.8501 24.0607L11.7895 23ZM14.6842 20.1053L15.7449 21.1659L16.8055 20.1053L15.7449 19.0446L14.6842 20.1053ZM13.1404 18.5614L12.0797 17.5007L11.019 18.5614L12.0797 19.6221L13.1404 18.5614ZM14.6842 17.0175L15.7449 18.0782L16.8055 17.0175L15.7449 15.9569L14.6842 17.0175ZM13.1404 15.4737L12.0797 14.413L11.019 15.4737L12.0797 16.5343L13.1404 15.4737ZM14.6842 13.9298L15.7449 14.9905L16.8055 13.9298L15.7449 12.8692L14.6842 13.9298ZM13.9043 14.2154C17.1046 13.3668 19.4649 10.4522 19.4649 6.98246H16.4649C16.4649 9.05771 15.0533 10.8071 13.1354 11.3156L13.9043 14.2154ZM19.4649 6.98246C19.4649 2.85001 16.1149 -0.5 11.9825 -0.5V2.5C14.4581 2.5 16.4649 4.50686 16.4649 6.98246H19.4649ZM11.9825 -0.5C7.85 -0.5 4.5 2.85001 4.5 6.98246H7.5C7.5 4.50686 9.50686 2.5 11.9825 2.5V-0.5ZM4.5 6.98246C4.5 9.80355 6.06184 12.2578 8.36086 13.5313L9.81458 10.9071C8.43113 10.1407 7.5 8.66928 7.5 6.98246H4.5ZM10.5877 20.2982V12.2192H7.58772V20.2982H10.5877ZM12.8501 21.9393L10.1484 19.2376L8.02706 21.3589L10.7288 24.0607L12.8501 21.9393ZM13.6236 19.0446L10.7288 21.9393L12.8501 24.0607L15.7449 21.1659L13.6236 19.0446ZM12.0797 19.6221L13.6236 21.1659L15.7449 19.0446L14.201 17.5007L12.0797 19.6221ZM13.6236 15.9569L12.0797 17.5007L14.201 19.6221L15.7449 18.0782L13.6236 15.9569ZM12.0797 16.5343L13.6236 18.0782L15.7449 15.9569L14.201 14.413L12.0797 16.5343ZM13.6236 12.8692L12.0797 14.413L14.201 16.5343L15.7449 14.9905L13.6236 12.8692ZM12.4592 13.8262L13.6236 14.9905L15.7449 12.8692L14.5806 11.7048L12.4592 13.8262Z",
  fill: "#627080",
  mask: "url(#path-1-inside-1)"
});

var _ref3 = /*#__PURE__*/React.createElement("circle", {
  cx: 12,
  cy: 6,
  r: 0.5,
  stroke: "#627080"
});

const SvgKey = ({
  svgRef,
  title,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  fill: "none",
  ref: svgRef
}, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref, _ref2, _ref3);

const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgKey, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/Key.28304b5c.svg";
export { ForwardRef as ReactComponent };